import React from 'react';
import { Box } from '@mui/material';
import IQOSLogo from '../assets/IQOS.png';
import IQOSLogo2 from '../assets/IQOS@2x.png';
import IQOSLogo3 from '../assets/IQOS@3x.png';
import { LanguageSelector } from './LanguageSelector';
import { useFlow } from '../contexts/FlowContext';
import { DataContext4 } from '../contexts/DataContext4';
import { DataContext3 } from '../contexts/DataContext3';
import { DataContext2 } from '../contexts/DataContext2';
import { DataContext } from '../contexts/DataContext';

function Header(props) {
  const { currentStep, steps } = props;
  const { flowNumber } = useFlow();
  return (
    <Box
      sx={{
        height: '66px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingInline: '16px',
        borderBottom: '1px solid #E9DFCC',
        position: 'relative',
      }}
    >
      <img
        src={IQOSLogo}
        srcSet={`
       ${IQOSLogo} 1x,
       ${IQOSLogo2} 2x,
       ${IQOSLogo3} 3x
     `}
        alt="IQOSLogo"
        style={{ width: '109px', height: 'auto' }} // Adjust size as needed
      />
      <LanguageSelector
        context={
          flowNumber === 3
            ? DataContext3
            : flowNumber === 2
              ? DataContext2
              : DataContext
        }
      />
      {steps > 0 && (
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            height: '2px',
            background: '#44546A',
            left: '0',
            width: (currentStep / steps) * 100 + '%',
          }}
        ></div>
      )}
    </Box>
  );
}

export default Header;
